﻿import "./scss/style.scss";

$(function () {
    //console.log($);
});